const privacyPolicy = `

<p>Welcome to the official website of Medhavi Skills University (Sikkim) ("MSU", "University", "we", "our" or "us").</p>

<p>Medhavi Skills University is committed to protecting the privacy, confidentiality and security of the personal information of its students, prospective students, parents, guardians, alumni, faculty members, employees, visitors, industry partners, recruiters, service providers and all other individuals who interact with the University through its website or otherwise.</p>

<p>By using our website or submitting information through our website, you acknowledge that you have read and understood this Privacy Policy.</p>

<p>This Privacy Policy should be read together with our Terms and Conditions and any other applicable policies or notices displayed on our website.</p>

<h2>1. Information We Collect</h2>

<p>Depending on how you interact with us, we may collect the following categories of information.</p>

<h3>1.1 Information You Provide Directly</h3>

<p>When you submit an enquiry, admission application, scholarship application, examination registration, contact form or other form on our website, we may collect information such as:</p>

<ul>
  <li>Name</li>
  <li>Email address</li>
  <li>Mobile or telephone number</li>
  <li>Date of birth or age, where required</li>
  <li>Gender, where required for a specific service or process</li>
  <li>Address and location details</li>
  <li>Educational qualifications and academic records</li>
  <li>Programme or course preferences</li>
  <li>Examination, scholarship or admission information</li>
  <li>Identification or verification information where required</li>
  <li>Information relating to parents, guardians or emergency contacts, where applicable</li>
  <li>Documents uploaded or submitted as part of an admission or academic process</li>
  <li>Information provided when communicating with the University</li>
  <li>Any other information that you voluntarily provide through our forms or communications</li>
</ul>

<p>You should provide accurate and complete information and should not submit information belonging to another person without appropriate authority or permission.</p>

<h3>1.2 Information Collected Automatically</h3>

<p>When you visit our website, certain technical information may be collected automatically, depending on the technologies implemented on the website.</p>

<p>This may include:</p>

<ul>
  <li>IP address</li>
  <li>Browser type and version</li>
  <li>Device type</li>
  <li>Operating system</li>
  <li>Website pages visited</li>
  <li>Date and time of access</li>
  <li>Referring website or source</li>
  <li>Approximate location derived from technical information</li>
  <li>Website interaction and navigation information</li>
  <li>Error logs and diagnostic information</li>
</ul>

<p>This information may be used to operate, secure, analyse and improve our website and digital services.</p>

<h2>2. Information Collected Through Enquiries and Admissions</h2>

<p>If you submit an enquiry or request information about a programme, MSU may use the information you provide to:</p>

<ul>
  <li>Respond to your enquiry</li>
  <li>Provide programme and admission information</li>
  <li>Contact you regarding your enquiry</li>
  <li>Assist with the admission process</li>
  <li>Communicate important application or examination information</li>
  <li>Provide information regarding scholarships, eligibility and applicable processes</li>
  <li>Facilitate counselling or academic guidance</li>
  <li>Process applications and related documentation</li>
  <li>Provide information about relevant University services</li>
</ul>

<p>Where permitted by applicable law, we may also contact you regarding programmes, admissions, events, scholarships or other educational opportunities that may be relevant to you.</p>

<p>You may request that we stop sending admissions, academic, outreach and informational communications by using the applicable unsubscribe or opt-out mechanism or by contacting us.</p>

<h2>3. How We Use Personal Information</h2>

<p>We may use personal information for legitimate educational, administrative, operational, security and communication purposes, including:</p>

<ol>
  <li>Processing enquiries and applications.</li>
  <li>Providing information about programmes and University services.</li>
  <li>Managing admissions and related processes.</li>
  <li>Conducting or administering examinations, aptitude tests and scholarship processes.</li>
  <li>Verifying information and documents.</li>
  <li>Communicating with prospective students, students, parents, guardians and other authorised persons.</li>
  <li>Managing student, applicant and administrative records.</li>
  <li>Providing academic, career, placement and related support.</li>
  <li>Organising events, webinars, counselling sessions and other University activities.</li>
  <li>Improving our website, user experience and digital services.</li>
  <li>Understanding website traffic and usage patterns.</li>
  <li>Detecting, preventing and addressing fraud, abuse, security incidents and technical problems.</li>
  <li>Complying with applicable laws, regulations, regulatory requirements and lawful requests.</li>
  <li>Protecting the rights, property, safety and security of MSU, its students, applicants, employees, visitors and other stakeholders.</li>
  <li>Performing other purposes that are communicated to you at the time your information is collected or otherwise permitted by applicable law.</li>
</ol>

<h2>4. How We Process Personal Information</h2>

<p>Where applicable, MSU may process personal information based on:</p>

<ul>
  <li>Your consent;</li>
  <li>Your request for information, admission or other services;</li>
  <li>Compliance with applicable legal or regulatory obligations;</li>
  <li>Legitimate educational, administrative and regualtory purposes permitted under applicable law; and</li>
  <li>Other lawful grounds available to the University under applicable law.</li>
</ul>

<p>Where processing is based on consent, you may have the right to withdraw consent, subject to applicable legal requirements and consequences.</p>

<h2>5. Cookies and Similar Technologies</h2>

<p>Our website may use cookies and similar technologies to improve functionality, understand website usage, remember preferences, maintain security and improve user experience.</p>

<p>Cookies may be used for purposes such as:</p>

<ul>
  <li>Essential website functionality</li>
  <li>Website performance</li>
  <li>Analytics and traffic measurement</li>
  <li>User preferences</li>
  <li>Security and fraud prevention</li>
  <li>Measuring the effectiveness of admissions outreach and informational campaigns, where applicable</li>
</ul>

<p>Some cookies may be provided by third-party technology or analytics providers.</p>

<p>You may be able to control or disable cookies through your browser settings. However, disabling certain cookies may affect the functionality or performance of parts of the website.</p>

<p>Where legally required, appropriate consent mechanisms may be provided for non-essential cookies.</p>

<h2>6. Analytics and Website Performance</h2>

<p>We may use analytics and similar technologies to understand how visitors use our website, including information about pages visited, traffic sources, device characteristics and general interaction patterns.</p>

<p>This information helps us:</p>

<ul>
  <li>Improve website navigation and usability;</li>
  <li>Identify technical problems;</li>
  <li>Understand the effectiveness of our website and campaigns;</li>
  <li>Improve content and digital services; and</li>
  <li>Develop a better experience for prospective students and other website users.</li>
</ul>

<p>Where third-party analytics services are used, their processing may also be governed by their respective privacy policies.</p>

<h2>7. Communications and Marketing</h2>

<p>If you provide your contact information through an enquiry, application, registration or other interaction, MSU may contact you through channels such as:</p>

<ul>
  <li>Telephone calls</li>
  <li>SMS</li>
  <li>Email</li>
  <li>WhatsApp or other messaging platforms</li>
  <li>Other communication channels made available by MSU</li>
</ul>

<p>Such communications may relate to your enquiry, admission, application, examination, scholarship, programme, event or other University-related matter.</p>

<p>Where permitted by applicable law, we may also send relevant promotional or informational communications.</p>

<p>You may opt out of promotional communications at any time. Opting out of promotional communication does not necessarily prevent us from sending essential service-related, transactional, administrative, security or legally required communications.</p>

<h2>8. Sharing and Disclosure of Information</h2>

<p>MSU does not sell your personal information as a commercial product.</p>

<p>We may disclose or share personal information where reasonably necessary for the purposes described in this Privacy Policy, including with:</p>

<ul>
  <li>Authorised University personnel and departments;</li>
  <li>Service providers and technology partners assisting us with website, hosting, communication, application processing, analytics, security or other operational services;</li>
  <li>Examination, scholarship, academic, accreditation or regulatory bodies where applicable;</li>
  <li>Industry, training, internship, apprenticeship or placement partners where necessary for an applicable programme or service;</li>
  <li>Payment processors or financial institutions where required for payment-related services;</li>
  <li>Government, statutory, regulatory or law-enforcement authorities where required or permitted by law;</li>
  <li>Professional advisers, auditors or legal advisers where necessary;</li>
  <li>Other parties where you have provided appropriate permission or where disclosure is otherwise permitted by applicable law.</li>
</ul>

<p>Where third parties process personal information on our behalf, we expect appropriate contractual, technical and organisational safeguards to be maintained.</p>

<h2>9. Third-Party Websites and Services</h2>

<p>Our website may contain links to external websites, platforms or services.</p>

<p>As stated in our Terms and Conditions, MSU is not responsible for the content, accuracy, privacy practices or security practices of third-party websites. Inclusion of a third-party link does not necessarily constitute endorsement or approval by MSU.</p>

<p>When you leave the MSU website and access a third-party website or service, your interaction with that third party may be governed by its own privacy policy and terms.</p>

<p>You should review the privacy policies of third-party websites before providing personal information to them.</p>

<h2>10. Payments and Financial Information</h2>

<p>Where online payment facilities are available, payments may be processed through third-party payment service providers.</p>

<p>MSU may receive transaction-related information necessary to confirm and administer a payment, but payment credentials such as card details, banking credentials or other sensitive payment information may be processed directly by the applicable payment service provider.</p>

<p>You should review the privacy and security practices of the payment provider used for your transaction.</p>

<h2>11. Data Retention</h2>

<p>We retain personal information only for as long as reasonably necessary for the purposes for which it was collected, including:</p>

<ul>
  <li>Providing requested services;</li>
  <li>Maintaining academic, admission, examination or administrative records;</li>
  <li>Complying with legal, regulatory or institutional requirements;</li>
  <li>Resolving disputes;</li>
  <li>Maintaining security and preventing misuse; and</li>
  <li>Establishing, exercising or defending legal claims.</li>
</ul>

<p>The appropriate retention period may vary depending on the nature of the information and the purpose for which it is processed.</p>

<p>When information is no longer required and there is no legal or legitimate requirement to retain it, we may delete, anonymise or otherwise dispose of it in accordance with applicable policies and law.</p>

<h2>12. Data Security</h2>

<p>MSU takes reasonable technical and organisational measures to protect personal information against unauthorised access, disclosure, alteration, misuse, loss or destruction.</p>

<p>Security measures may include access controls, authentication mechanisms, monitoring, secure systems, contractual safeguards and other measures appropriate to the nature of the information and the processing involved.</p>

<p>However, no method of transmission or electronic storage can be guaranteed to be completely secure. Therefore, while we take reasonable measures to protect information, we cannot guarantee absolute security.</p>

<h2>13. Your Responsibilities</h2>

<p>You are responsible for ensuring that information submitted by you is accurate, complete and current.</p>

<p>You should not:</p>

<ul>
  <li>Submit false or misleading information;</li>
  <li>Submit another person’s personal information without appropriate authority;</li>
  <li>Share account credentials or passwords with unauthorised persons;</li>
  <li>Attempt to gain unauthorised access to University systems;</li>
  <li>Circumvent security controls; or</li>
  <li>Use the website for unlawful or fraudulent purposes.</li>
</ul>

<h2>14. Children’s and Minors’ Information</h2>

<p>Certain educational services may involve applicants or students who are minors.</p>

<p>Where personal information relating to a child is collected, MSU will process such information in accordance with applicable law and any required consent or authorisation mechanisms.</p>

<p>Parents or lawful guardians may contact MSU regarding information submitted in connection with a minor where they are legally entitled to do so.</p>

<p>If you believe that personal information relating to a child has been submitted to MSU improperly, please contact us using the details provided below.</p>

<h2>15. Your Privacy Rights</h2>

<p>Subject to applicable law, you may have rights relating to your personal information, including rights to:</p>

<ul>
  <li>Obtain information about the personal data being processed;</li>
  <li>Request correction of inaccurate or incomplete information;</li>
  <li>Subject to applicable law and the University's statutory obligations, request deletion of personal information where legally applicable;</li>
  <li>Withdraw consent where processing is based on consent;</li>
  <li>Exercise other rights available to you under applicable data-protection law; and</li>
  <li>Raise a grievance regarding the processing of your personal information.</li>
</ul>

<p>Requests may be subject to applicable verification requirements and legal or regulatory limitations.</p>

<p>To exercise an applicable right or raise a privacy-related concern, please contact us using the details provided in the “Contact Us” section.</p>

<h2>16. Consent Withdrawal</h2>

<p>Where MSU processes personal information based on your consent, you may withdraw that consent by contacting us.</p>

<p>Withdrawal of consent will not affect the lawfulness of processing carried out before withdrawal.</p>

<p>In certain circumstances, withdrawing consent may affect our ability to provide a particular service, process or communication where that information is necessary for the relevant purpose.</p>

<h2>17. Data Breaches and Security Incidents</h2>

<p>MSU shall take reasonable steps to investigate, mitigate and respond to security incidents involving personal information in accordance with applicable law and comply with applicable legal requirements regarding reporting or notification of personal data breaches.</p>

<h2>18. International Data Transfers</h2>

<p>Some of our technology, hosting, communication, analytics or other service providers may process information using infrastructure located outside your state or country.</p>

<p>Where personal information is transferred or processed outside India, MSU will take such steps as may be required under applicable law.</p>

<h2>19. Changes to This Privacy Policy</h2>

<p>MSU may update this Privacy Policy from time to time to reflect changes in our website, services, technology, legal requirements or institutional practices.</p>

<p>When changes are made, the updated version will be published on this page with a revised “Last Updated” date.</p>

<p>You are encouraged to review this page periodically to remain informed about how your information is handled.</p>

<h2>20. Relationship With the Terms and Conditions</h2>

<p>This Privacy Policy forms an important part of the terms governing use of the MSU website.</p>

<p>Our existing Terms and Conditions provide that information relating to your use of the Site and information provided by you may be used and transferred in accordance with the Privacy Policy. The Terms and Conditions also address third-party websites, disclaimers, content editing and deletion, indemnification, non-transferability and other conditions relating to use of the Site.</p>

<p>In the event of any inconsistency between this Privacy Policy and a specific privacy notice provided at the point of data collection, the specific notice will apply to the extent required by applicable law.</p>

<h2>21. Grievance and Privacy Enquiries</h2>

<p>If you have questions, concerns, requests or complaints relating to this Privacy Policy or the handling of your personal information, please contact:</p>

<p><strong>Medhavi Skills University</strong><br>
Website: www.msu.edu.in<br>
Email: contact@msu.edu.in<br>
Grievance Officer: Name and Designation<br>
Telephone: +91 9874875876</p>

<p>For admissions-related enquiries, you may also contact:</p>

<p>Email: admissions@msu.edu.in<br>
Telephone: +91 98748 75876</p>

<p>We will review and address privacy-related requests and grievances in accordance with applicable law and our internal procedures.</p>

<h2>22. Governing Law</h2>

<p>This Privacy Policy shall be governed by and construed in accordance with the laws of India.</p>

<p>Any dispute arising out of or relating to this Privacy Policy or the use of this website shall be subject to the exclusive jurisdiction of the competent courts at Gangtok, Sikkim.</p>

<h2>23. Important Notice</h2>

<p>This Privacy Policy is intended to provide transparency regarding the University’s handling of personal information. It does not create contractual rights beyond those provided under applicable law.</p>

<p>The University’s services, programmes, admissions, scholarships, fees, examinations and other academic matters may be subject to separate rules, policies, regulations, programme-specific terms and applicable statutory or regulatory requirements.</p>

<p>For the University’s general website-use provisions, please refer to the Terms and Conditions page.</p>`

export default privacyPolicy;
